export const VITE_BUILD_ENV = import.meta.env.VITE_BUILD_ENV;

export const isPro = VITE_BUILD_ENV == "pro";

export const isTest = VITE_BUILD_ENV == "test";
export const isDev = VITE_BUILD_ENV == "dev";

export const env = VITE_BUILD_ENV;

export const config = {
    direct_link:
        import.meta.env.VITE_DIRECT_LINK || "https://t.me/UXUYDexBot/App",
    wallet_direct_link:
        import.meta.env.VITE_DIRECT_WALLET_LINK || "https://t.me/UXUYbot/app",
    web_app_url:
        import.meta.env.VITE_WEB_APP_URL || "https://miniapp.uint512.com",
    share_link_prefix:
        import.meta.env.VITE_APP_X_SHARE_LINK_PREFIX ||
        "https://t.uxuy.me/tshare",
    image_proxy_link_perfix:
        import.meta.env.VITE_APP_IMAGE_PROXY_LINK_PREFIX ||
        "https://t.uxuy.me/static/",

    cdn_host: "https://chain-cdn.uxuy.com",
    default_show_private_chain_key: "ethereum",
    agreement_link: "https://docs.uxuy.com/term-of-service/index.html",

    share_earn_text:
        "🚀 Join UXUY Now and Earn Bitcoin 🎉\n\nHow to Earn 💰\n\n• 📲  Click to get a red packet of up to 1000 SATS for new users 🤑\n•  🌟 Grand launch on TG platform, earn SATS with just a click 🎯\n•  🔥 More Bitcoin earning opportunities await, join us now. 📈",

    api: {
        endpoint:
            import.meta.env.VITE_API_BASE_URL || "https://api-dev.dexmama.com",
    },
    ton: {
        rpc: "https://toncenter.com/api/v2/jsonRPC",
    },
    firedata: {
        api: "https://firedata.ourdex.com",
    },
};
